import { create } from 'zustand'
import { Node } from '../useApi'

export interface FiltersStore {
    rootNode: Node | undefined
    setRootNode: (node: Node | undefined) => void
}

const useFiltersStore = create<FiltersStore>((set) => ({
    rootNode: undefined,
    setRootNode: (node) => {
        set({ rootNode: node })
    },
}))

export default useFiltersStore
